<template>
  <div class="card">
    <img class="logo" src="/images/terrassa-logo.png" alt="Logo Terrassa" />
    <h2>Benvingut/da! Què vols fer avui?</h2>
    <div class="bifurcaciones">
      <div class="bifurcacion-card" @click="goTramitacio">
        <font-awesome-icon icon="file-signature" class="card-icon" />
        <span class="card-title">Tramitació</span>
        <span class="card-subtitle">Crear nova vetlla</span>
      </div>
      <div class="bifurcacion-card" @click="goRecepcio">
        <font-awesome-icon icon="door-open" class="card-icon" />
        <span class="card-title">Recepció</span>
        <span class="card-subtitle">Gestionar sales</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { faFileSignature, faDoorOpen } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
library.add(faFileSignature, faDoorOpen);

export default defineComponent({
  setup() {
    const router = useRouter();

    const goTramitacio = () => {
      router.push({ name: "vetllaCreate" });
    };

    const goRecepcio = () => {
      router.push({ name: "sales" });
    };

    return {
      goTramitacio,
      goRecepcio,
    };
  },
});
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2em;

  padding: 1em;
  border-radius: $rounded-border;

  background-color: $bg-color;

  width: 80%;
  @media (max-width: 768px) {
    width: 96%;
  }
}

.logo {
  width: 16em;
}

.bifurcaciones {
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2em;
}

.bifurcacion-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8em;

  width: 14em;
  height: 12em;
  padding: 1.5em;

  background-color: $primary-color;
  color: white;
  border-radius: $rounded-border;

  cursor: pointer;
  transition: all 200ms ease-out;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(74, 40, 134, 0.35);
  }
}

.card-icon {
  font-size: 2.5em;
}

.card-title {
  font-size: 1.4em;
  font-weight: bold;
}

.card-subtitle {
  font-size: 0.9em;
  opacity: 0.85;
}
</style>
